module.exports = __webpack_public_path__ + "img/module-find-clinic.c869905e.svg";